import { render, staticRenderFns } from "./Guide4.vue?vue&type=template&id=20c6f7e2"
import script from "./Guide4.vue?vue&type=script&lang=js"
export * from "./Guide4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports